export default "__VITE_ASSET__5SrC2Yxy__"